import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface ClientApiItem {
  _id: string;
  custom_client_id: string;
  client_name: string;
  client_code: string;
  client_status: 'active' | 'inactive' | 'terminated';
  pms?: string;
  specialty?: string;
  aging_report?: 'available' | 'not available';
  meta?: { status?: string };
  createdAt?: string;
  updatedAt?: string;
}

export interface FailedClientUploadRow {
  client_name?: string | null;
  client_code?: string | null;
  reason?: string;
}

export interface UploadClientsFileResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    inserted_count?: number;
    failed_count?: number;
    failed_items?: FailedClientUploadRow[];
  };
}

export interface ClientsListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    clients?: ClientApiItem[];
    count?: number;
  } | ClientApiItem[];
}

export interface UpsertClientPayload {
  id?: string;
  client_name: string;
  client_code: string;
  client_status?: 'active' | 'inactive' | 'terminated';
  pms?: string;
  specialty?: string;
  aging_report?: 'available' | 'not available';
}

export interface ClientMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: ClientApiItem | null;
}

export const getClients = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  client_status?: 'active' | 'inactive';
}): Promise<ClientsListResponse> => {
  return api.get<ClientsListResponse>(API_ENDPOINTS.clients.list, { params });
};

export const upsertClient = async (
  payload: UpsertClientPayload,
): Promise<ClientMutationResponse> => {
  return api.post<ClientMutationResponse, UpsertClientPayload>(
    API_ENDPOINTS.clients.upsert,
    payload,
  );
};

export const deleteClient = async (id: string): Promise<ClientMutationResponse> => {
  return api.delete<ClientMutationResponse>(
    `${API_ENDPOINTS.clients.list}/${id}`,
  );
};

export const uploadClientsFile = async (file: File): Promise<UploadClientsFileResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post<UploadClientsFileResponse, FormData>(API_ENDPOINTS.clients.uploadFile, formData);
};
